import React from "react";
import "../App.css";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  palette: {
    type: "light",
  },
  intro: {
    flexFlow: "row nowrap",
    alignItems: "center",
    height: "80vh",
    minHeight: "20em",
  },
  title: {
    flexGrow: 4,
  },
  imageItem: {
    flexGrow: 3,
    justifyContent: "center", // these don't work
    alignItems: "center",
    flexBasis: "0",
    display: "block",
    marginLeft: "1em",
  },
  image: {
    maxWidth: "40vw",
    maxHeight: "60vh",
    display: "block",
    margin: "auto",
  },
}));

export default function Intro() {
  const classes = useStyles();

  return (
    <Grid container className={classes.intro}>
      <Grid item xs className={classes.title}>
        <Typography variant="h1" component="h1">
          Hello, I'm Christiana
        </Typography>

        <Typography variant="body1" component="p">
          <p>
            Software engineering student, with interest in UI/UX and product
            management.
          </p>
          <p>Currently based in Montreal, QC.</p>
        </Typography>
      </Grid>

      <Grid item xs className={classes.imageItem}>
        <img className={classes.image} alt="cc" src="/assets/cc.png" />
      </Grid>
    </Grid>
  );
}
